import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, Output, EventEmitter, ChangeDetectorRef, ElementRef } from '@angular/core';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CdkDragDrop, CdkDragMove, moveItemInArray } from '@angular/cdk/drag-drop';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { CatalogPreviewComponent } from '../catalog-preview/catalog-preview.component';
import { ConfirmPopupComponent } from '../../../Common/Components/confirm-popup/confirm-popup.component';
import { ApiService } from '../../../Services/api.service';
import { DecodeSpecialCharPipe } from '../../../Common/Components/pipe/DecodeSpecialCharPipe/decode-special-char.pipe';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

@Component({
  selector: 'app-category-accordion-child',
  standalone: true,
  imports: [NzIconModule, NzCollapseModule, CommonModule, NzButtonModule, NzTagModule, DragDropModule,
    NzModalModule, NzDropDownModule, NzMenuModule, CatalogPreviewComponent, NzToolTipModule, ConfirmPopupComponent, DecodeSpecialCharPipe],
  templateUrl: './category-accordion-child.component.html',
  styleUrl: './category-accordion-child.component.scss'
})


export class CategoryAccordionChildComponent implements OnChanges {
  @Input() categories: any = [];
  @Input() catalogId: string = '';
  @Input() reOrder: boolean = false;
  selectedSeqId: any = "";
  @Output() emitSeqId = new EventEmitter<string>();
  lots: any;
  showModal: boolean = false;
  modalMessage: string = '';
  modalButton: string = '';
  categoryDetails: any;
  productSelected: boolean = false;
  previewDetails: any;
  imageLoading: boolean = false;
  activeSelection = {
    selectedSeqId: ''
  };

  constructor(public apiService: ApiService, private cdr: ChangeDetectorRef, private elementRef: ElementRef) { }

  ngOnChanges() {
  }

  trackByCategoryId(index: number, category: any): number {
    return category['seqno'];  // Or any unique identifier
  }

  onPanelClose(state: any, childNode: any, parentList: any, index: number): void {
    // Pass the childNode["seqno"] to protect it during sibling cleanup
    this.addIsOpenProperty(parentList[index], false, childNode["seqno"]);

    childNode.isOpen = state;
    childNode.hovered = false;

    if (!state) {


      if (childNode.lots && Array.isArray(childNode.lots)) {
        childNode.lots.forEach((lot: any) => {
          lot.hovered = false;
          lot.isHovered = false;
        });
      }
    }

    if (state) {
      setTimeout(() => {
        childNode.renderChild = true;
      }, 150);
    } else {
      childNode.renderChild = false;
    }
  }


  addIsOpenProperty(node: any, isOpenValue: boolean, excludeSeqId?: any) {
    if (!node) return;

    node.isOpen = isOpenValue;
    node.hovered = false;

    if (!isOpenValue) {
      node.isMenuOpen = false;
      node.isHovered = false;


      // if (node["seqno"] !== excludeSeqId) {
      //   if (this.apiService.activeSelection.selectedSeqId == node["seqno"]) {
      //     this.apiService.activeSelection.selectedSeqId = '';
      //   }
      // }

      if (node.lots && Array.isArray(node.lots)) {
        node.lots.forEach((lot: any) => {
          lot.hovered = false;
          lot.isHovered = false;

          // FIX: Apply the same exclusion check to lots
          if (lot["seqno"] !== excludeSeqId) {
            if (this.apiService.activeSelection.selectedSeqId == lot["seqno"]) {
              this.apiService.activeSelection.selectedSeqId = '';
            }
          }
        });
      }
    }

    const childBranch = node.categories || node.category;

    if (childBranch && Array.isArray(childBranch)) {
      childBranch.forEach((childNode: any) =>
        // Pass the exclusion ID down through the recursion
        this.addIsOpenProperty(childNode, isOpenValue, excludeSeqId)
      );
    }
  }

  preventCollapse(event: Event): void {
    event.stopPropagation();
  }

  toggleCollapse(event: Event): void {
    event.stopPropagation();
  }

  drop(event: CdkDragDrop<any[]>, parentCategory: any) {
    moveItemInArray(parentCategory, event.previousIndex, event.currentIndex);
  }

  onChildDrop(event: CdkDragDrop<any[]>, parentCategory: any) {
    this.drop(event, parentCategory); // reuse logic
  }

  onDragMove(event: CdkDragMove): void {
    const container = this.elementRef.nativeElement.closest('.tree-container');
    if (!container) return;

    const rect = container.getBoundingClientRect();
    const { y } = event.pointerPosition;
    const scrollSpeed = 15;
    const edgeThreshold = 50;

    if (y < rect.top + edgeThreshold) {
      container.scrollTop -= scrollSpeed;
    } else if (y > rect.bottom - edgeThreshold) {
      container.scrollTop += scrollSpeed;
    }
  }

  handleHover(category: any, parentList: any[], state: boolean) {
    if (state) {

      this.addIsMenuOpenProperty(parentList, false);
      category['hovered'] = true;
    } else {
      category['hovered'] = !!category['isMenuOpen'];
    }
  }

  removeHover(category: any, parentList: any[], state: boolean) {

    parentList.forEach((node: any) => {
      if (!node['isMenuOpen']) {
        node['hovered'] = false;
      }
    });
  }

  onMenuLeave(category: any) {
    category['hovered'] = false;
    category['isHovered'] = false;
    category['isMenuOpen'] = false;
  }

  loadChildCategory(category: any) {
    if (!category) return;

    this.selectedSeqId = category["seqno"];
    this.apiService.activeSelection.selectedSeqId = category["seqno"];

    this.lots = category["lots"];

    if (this.lots && this.lots.length > 0) {
      category.isOpen = true;
      category.renderChild = true;
    }

    this.emitSeqId.emit(category);
  }

  addIsMenuOpenProperty(node: any, isOpenValue: boolean) {
    if (!node) return;

    if (!Array.isArray(node)) {
      node.isMenuOpen = isOpenValue;

      if (isOpenValue) {
        node.hovered = true;
      }

      const childBranch = node.categories || node.category;
      if (childBranch) {
        this.addIsMenuOpenProperty(childBranch, isOpenValue);
      }
      return;
    }

    node.forEach((childNode: any) => this.addIsMenuOpenProperty(childNode, isOpenValue));
  }

  duplicateCategory(catDetails: any, isProduct = false) {
    if (isProduct) {
      this.modalMessage = 'Are you sure you want to duplicate selected Product?';
    } else {
      this.modalMessage = 'Are you sure you want to duplicate selected Category?';
    }
    this.modalButton = 'Duplicate';
    this.showModal = true;
    this.categoryDetails = catDetails;
  }

  deleteCategory(catDetails: any, isProduct = false) {
    if (isProduct) {
      this.modalMessage = 'Are you sure you want to delete selected Product?';
    } else {
      this.modalMessage = 'Are you sure you want to delete selected Category?';
    }
    this.modalButton = 'Delete';
    this.showModal = true;
    this.categoryDetails = catDetails
  }

  onConfirm() {
    if (this.modalButton == 'Delete') {
      this.apiService.deleteCategory(this.categoryDetails.seqno).subscribe(res => {
        this.categoryDetails = {};
        this.apiService.triggerAction('delete');
        this.apiService.createNotification('success', res?.message);
      }, (error: any) => {
        this.apiService.createNotification('error', error?.error.message);
      })
    }

    if (this.modalButton == 'Duplicate') {
      this.apiService.duplicateCategory(this.catalogId, this.categoryDetails.seqno).subscribe(res => {
        this.categoryDetails = {};
        this.apiService.triggerAction('duplicate');
        this.apiService.createNotification('success', res?.message);
      }, (error: any) => {
        this.apiService.createNotification('error', error?.error.message);
      })
    }
  }


  preview(child: any) {
    child.isPreviewOpen = true;
    this.imageLoading = true;
    this.apiService.getCategoryPreviewDetail(child.seqno).subscribe(response => {
      this.previewDetails = response;
      this.imageLoading = false;
    }, (error: any) => {
      this.apiService.createNotification('error', error?.error.message);
      this.imageLoading = false;
    })
  }
}

